import { Box } from "@mui/material";

import { useListCctlsQuery } from "api/public/cctlDirectory/cctlDirectory.api";
import { CctlTableEntry } from "api/public/cctlDirectory/cctlDirectory.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { cctlTableColumns } from "./CCTLTable.columns";

interface CCTLTableViewProps {
  sidebarFilters: {
    status?: string;
  };
}

const EMPTY_CCTLS: CctlTableEntry[] = [];

export default function CCTLTableView({ sidebarFilters }: CCTLTableViewProps) {
  const { data: cctls = EMPTY_CCTLS } = useListCctlsQuery({
    status: sidebarFilters.status,
  });

  return (
    <Box sx={{ mt: 4 }}>
      <DefaultDataGrid
        title="Showing"
        columns={cctlTableColumns}
        rows={cctls}
        getRowId={(row) => row.cctl_id}
      />
    </Box>
  );
}
